import { mobileApiRequest } from '../../apiRequests'

/**
 * Get current BYOK AI settings for an account
 * @param {string} accountID - Account ID
 * @returns {Promise<{aiProvider: string|null, hasCustomKey: boolean}>}
 */
export const getAccountAISettings = async (accountID) => {
    const action = {
        action: 'getAccountAISettings',
        accountID,
    }
    const response = await mobileApiRequest(action)
    return response
}

/**
 * Update BYOK AI settings for an account
 * @param {string} accountID - Account ID
 * @param {string|null} aiProvider - "claude", "openai", or null to clear
 * @param {string|null} aiApiKey - API key or null to clear
 * @returns {Promise<{success: boolean, message: string, aiProvider: string|null, hasCustomKey: boolean}>}
 */
export const updateAccountAISettings = async (accountID, aiProvider, aiApiKey) => {
    const action = {
        action: 'updateAccountAISettings',
        accountID,
        aiProvider,
        aiApiKey,
    }
    const response = await mobileApiRequest(action)
    return response
}

/**
 * Test an API key before saving it
 * @param {string} provider - "claude" or "openai"
 * @param {string} apiKey - API key to test
 * @returns {Promise<{success: boolean, message?: string, errorMessage?: string}>}
 */
export const testAccountAPIKey = async (provider, apiKey) => {
    const action = {
        action: 'testAccountAPIKey',
        provider,
        apiKey,
    }
    const response = await mobileApiRequest(action)
    return response
}
